import React, { Component } from 'react';
import { Container, connect, ToastContainer, Row, Col } from '../components';
import SignIn from './SignIn';
import SignUp from './SignUp';
import ForgetPassword from './forgetpassword';
import { withTranslation } from 'react-i18next';
import LanguageSwitcher from '../i18n/LanguageSwitcher';

class Auth extends Component {
  componentDidMount() {
    if (this.props.authUser !== null) {
      this.props.history.push('/app/dashboard/index');
    }
  }

  changeView = (view) => {
    this.props.history.push(`/${view}`);
  };

  render() {
    const { pathname } = this.props.location;
    const { t } = this.props;

    const form = pathname.includes('signup')
      ? 'signup'
      : pathname.includes('forgot')
        ? 'forgot'
        : 'login';

    return (
      <Container fluid={true} className="auth-container">
        <Row className="sidebars">
          <Col md="4" xs="12" className="left-sidebar">
            <Row>
              <Col md="12" className="logo-div" onClick={() => this.changeView('signin')}>
                <img
                  src={require('assets/images/logo.png')}
                  className="logo-login"
                  alt="logo"
                />
                <div style={{ border: "3px solid #e06000", height: 'fit-content', borderRadius: '10%', backgroundColor: "#e06000" }}>
                  <LanguageSwitcher />
                </div>
              </Col>

              <Col md="12" onClick={() => this.changeView('signin')} className={'p-0 m-0'}>
                <h3 className={`auth-tab ${form === 'login' || form === 'forgot' ? 'active' : ''}`}>
                  {t('auth.signinTtile')}
                </h3>
              </Col>

              <Col md="12" onClick={() => this.changeView('signup')} className={'p-0 m-0'}>
                <h3 className={`auth-tab ${form === 'signup' ? 'active' : ''}`}>
                  {t('auth.signupTtitle')}
                </h3>
              </Col>
            </Row>
          </Col>

          <Col md="8" xs="12">
            {form === 'login' ? (
              <SignIn changeView={this.changeView} />
            ) : form === 'forgot' ? (
              <ForgetPassword changeView={this.changeView} />
            ) : (
              <SignUp />
            )}
            <ToastContainer />
          </Col>
        </Row >
      </Container >
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { authUser } = auth;
  return { authUser };
};

export default connect(mapStateToProps, null)(withTranslation()(Auth));
